<template>
  <div>
    <div v-if="! this.checking">
      <span v-if="this.connected === null" title='Disconnected'>
        <CIcon size="xl" name="cilWifiSignalOff" ></CIcon>
      </span>
      <span v-if="this.connected !== null" title='Connected'>
        <CIcon size="xl" name="cilWifiSignal4"></CIcon>
      </span>
    </div>
    <div v-if="this.checking">Checking...</div>
  </div>
</template>

<script>
export default {
  name: 'Devicestatus',
  props: {
    device: Object
  },
  data: () => ({
    connected: null,
    checking: false
  }),
  mounted: function() {
    this.statusLoop()
  },
  beforeDestroy: function(){
    clearInterval(this.statusCheck)
  },
  methods: {
    statusLoop: function() {
      this.fetchStatus(this)
      this.statusCheck = setInterval(() => {
      var that = this;
      that.checking = true
      that.fetchStatus(that)
      
      }, 120000)
    },
    fetchStatus: function(that){
      that.$portalapi.get('/myaccount/devicesession', 
        { params: {mac: that.device.macaddress}})
        .then((response) => {
          that.connected = response.data
          that.checking = false            
        })
        .catch((error) => {
          that.connected = null
          that.checking = false          
        })
    }

  }
  // go and get the current status of the device connection
}
</script>

<style lang="scss" scoped>

</style>
